import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { RECOMMENDATION_TYPES } from '../consts';

export const withAdsAutoApply = (WrappedComponent) => {
  class HoC extends React.Component {
    static displayName = `withAdsAutoApply(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      odata: PropTypes.PropTypes.shape({
        get: PropTypes.func.isRequired,
      }).isRequired,
      cid: PropTypes.string.isRequired,
      aid: PropTypes.string.isRequired,
      showIntermediateView: PropTypes.bool,
      permissions: PropTypes.shape({}),
      type: PropTypes.string,
      data: PropTypes.objectOf(PropTypes.any),
      dataService: PropTypes.func.isRequired,
    };

    static defaultProps = {
      showIntermediateView: false,
      permissions: {},
      type: null,
      data: {},
    };

    state = {
      campaignAutoApplyStatus: {},
    };

    componentDidMount = () => {
      this.reload();
    };

    componentWillUnmount = () => {
      this.cancel();
    };

    reload = () => {
      this.cancel();

      this.loadToken = createAsyncToken(this.props.dataService
        .getAutoApplyOptInStatus())
        .on({
          onSuccess: (response) => {
            this.setState({
              campaignAutoApplyStatus: {
                [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: _.find(response.data.value, item => item.RecommendationType === RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS).IsOptIn,
              },
            });
          },
        });
    };

    cancel = () => {
      if (this.loadToken) {
        this.loadToken.cancel();
      }
    };

    render = () => {
      const type = this.props.type || this.props.data.type;
      if (this.state.campaignAutoApplyStatus[type] === undefined
        && !this.props.showIntermediateView) {
        return null;
      }

      return (<WrappedComponent
        {...this.props}
        campaignAutoApplyStatus={this.state.campaignAutoApplyStatus}
      />);
    };
  }

  return hoistNonReactStatics(HoC, WrappedComponent);
};
